import { StyleProps } from "@chakra-ui/system"
import styled, { css } from "styled-components"

import { Color, TextSize } from "~/consts/style-mixins"

type Props = StyleProps & {
  className?: string
  count?: number
  size?: "Small" | "Medium" | "Large"
}

const Badge = ({ className, count, size = "Medium" }: Props) => (
  <Container className={className} styleBySize={styleBySize[size]}>
    {count && count > 99 ? "99+" : count}
  </Container>
)

const styleBySize = {
  Small: `
    height: 10px;
    width: 10px;
    border-radius: 5px;
    font-size: 0;
  `,
  Medium: `
    height: 16px;
    min-width: 16px;
    font-size: ${TextSize._2XS}px;
    border-radius: 10px;
    padding: 0 3px;
  `,
  Large: `
    height: 18px;
    min-width: 18px;
    font-size: ${TextSize._2XS}px;
    border-radius: 10px;
    padding: 0 3px;
  `,
}

const Container = styled.div<{ styleBySize: string } & Props>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: ${Color.White};
  background: ${Color.Attention};

  ${({ styleBySize }) => css`
    ${styleBySize}
  `};
`

export default Badge
